import { UserManager, User } from 'oidc-client'
import { azureConfig } from '../config/azure'

const userManager = new UserManager(azureConfig)
// Log.logger = console
// Log.level = Log.INFO
function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )

  return JSON.parse(jsonPayload)
}
const mapUserToOIDCUser = (user) => {
  const userSettings = {}

  userSettings.id_token = user.id_token
  userSettings.session_state = user.session_state
  userSettings.access_token = user.access_token
  userSettings.refresh_token = user.refresh_token
  userSettings.token_type = user.token_type
  userSettings.scope = user.scope
  userSettings.profile = parseJwt(user.id_token)
  userSettings.expires_at = user.expires_at
  userSettings.state = user.state

  // userSettings.not_before = user.not_before
  // userSettings.id_token_expires_in = user.id_token_expires_in
  // userSettings.profile_info = user.profile_info
  // userSettings.refresh_token_expires_in = user.refresh_token_expires_in

  return new User(userSettings)
}
const registration = () => {
  window.location.replace(
    'https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_RegistroUsuarioExterno&client_id=f9000169-4fa0-4b4a-8610-fe9d93158af7&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A3000&scope=openid&response_type=id_token&prompt=login',
  )
}

export const authServiceIFI = {
  getUser: () => userManager.getUser(),
  getUserInfo: (token) => parseJwt(token),
  storeUser: (user) => userManager.storeUser(mapUserToOIDCUser(user)),
  login: () => userManager.signinRedirect(),
  loginCallback: () => userManager.signinRedirectCallback(),
  registration: () => registration(),
  renewToken: () => userManager.signinSilent(),
  logout: () => userManager.signoutRedirect(),
}
